import React, { useState } from "react";
import {
  CModal,
  CModalHeader,
  CModalTitle,
  CModalBody,
  CModalFooter,
  CButton,
  CForm,
  CInputGroup,
  CInputGroupText,
  CFormInput,
  CSpinner,
} from "@coreui/react";
import { ReactComponent as EyeIcon } from "../../assets/icons/eye.svg";
import { ReactComponent as EyeSlashIcon } from "../../assets/icons/eye-slash.svg";
import { verifyAdminPassword } from "../../utils/backend";
import { setElevation } from "../../utils/elevation";

// Password re-entry modal for the password-gated dashboard amount widgets
// (ACS Dashboard BRD 3 July 2026, "Must login with Password"). On success the
// short-lived elevation token is stored and onUnlocked() lets the dashboard
// fetch and reveal the amounts.
const UnlockAmountsModal = ({ visible, onClose, onUnlocked }) => {
  const [password, setPassword] = useState("");
  const [isPasswordVisible, setIsPasswordVisible] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);
  const [error, setError] = useState("");

  const resetAndClose = () => {
    setPassword("");
    setError("");
    setIsPasswordVisible(false);
    onClose();
  };

  const handleSubmit = async (event) => {
    event.preventDefault();
    if (!password) {
      setError("Password is required");
      return;
    }
    setIsSubmitting(true);
    setError("");
    try {
      const response = await verifyAdminPassword({ password });
      const { elevation_token, expires_in } = response.data;
      setElevation(elevation_token, expires_in);
      setPassword("");
      setIsPasswordVisible(false);
      onUnlocked();
    } catch (err) {
      setError(err.message || "Password is incorrect. Please try again.");
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <CModal visible={visible} onClose={resetAndClose} alignment="center">
      <CModalHeader>
        <CModalTitle>Confirm your password</CModalTitle>
      </CModalHeader>
      <CForm onSubmit={handleSubmit}>
        <CModalBody>
          <p className="text-muted" style={{ marginBottom: "12px" }}>
            Sales and transaction amounts are protected. Please re-enter your
            login password to view them.
          </p>
          <CInputGroup>
            <CFormInput
              type={isPasswordVisible ? "text" : "password"}
              placeholder="Enter your password"
              value={password}
              autoFocus
              invalid={!!error}
              onChange={(e) => {
                setPassword(e.target.value);
                setError("");
              }}
            />
            <CInputGroupText
              onClick={() => setIsPasswordVisible(!isPasswordVisible)}
              style={{ cursor: "pointer" }}
            >
              {isPasswordVisible ? (
                <EyeIcon style={{ width: "20px", height: "20px" }} />
              ) : (
                <EyeSlashIcon style={{ width: "20px", height: "20px" }} />
              )}
            </CInputGroupText>
          </CInputGroup>
          {error && (
            <div className="text-danger" style={{ marginTop: "8px" }}>
              {error}
            </div>
          )}
        </CModalBody>
        <CModalFooter>
          <CButton color="secondary" onClick={resetAndClose} disabled={isSubmitting}>
            Cancel
          </CButton>
          <CButton color="primary" type="submit" disabled={isSubmitting}>
            {isSubmitting ? <CSpinner size="sm" /> : "Unlock"}
          </CButton>
        </CModalFooter>
      </CForm>
    </CModal>
  );
};

export default UnlockAmountsModal;
